export default "__VITE_PUBLIC_ASSET__73f13bce__"